import { render, staticRenderFns } from "./ApiSamples.vue?vue&type=template&id=2f49598e&"
import script from "./ApiSamples.vue?vue&type=script&lang=js&"
export * from "./ApiSamples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports